import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "../../_LOS/services/los.service";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { MasterService } from "src/app/Shared/app.Masters.Service";

declare var $: any;

@Component({
  selector: "app-quickloan-cibil-report",
  templateUrl: "./quickloan-cibil-report.component.html",
  styleUrls: ["./quickloan-cibil-report.component.scss"],
  standalone: false,
})
export class QuickloanCibilReportComponent implements OnInit, OnChanges {
  readonly tuLogoSrc: string = 'data:image/png;base64,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';
  @Input() cibilResponse: any;

  showSpinner: boolean = false;
  CibilData: any = null;
  consumer: any = null;
  summary: any = null;
  processedAccounts: any[] = [];
  processedEnquiries: any[] = [];

  PurposeList: any[] = [];
  SuitFiled: any[] = [];
  CreditFacilityStatus: any[] = [];
  CibilAcore_List: any[] = [];

  accountTypeMap: { [key: string]: string } = {
    "01": "Auto Loan (Personal)",
    "02": "Housing Loan",
    "03": "Property Loan",
    "04": "Loan Against Shares / Securities",
    "05": "Personal Loan",
    "06": "Consumer Loan",
    "07": "Gold Loan",
    "08": "Education Loan",
    "09": "Loan to Professional",
    "10": "Credit Card",
    "11": "Lease",
    "12": "Overdraft",
    "13": "Two-Wheeler Loan",
    "14": "Commercial Vehicle Loan",
    "15": "Commercial Equipment Loan",
    "16": "Construction Equipment Loan",
    "17": "Tractor Loan",
    "18": "Corporate Credit Card",
    "31": "Secured Credit Card",
    "32": "Used Car Loan",
    "33": "Construction Loan",
    "34": "Loan Against Bank Deposits",
    "35": "Business Loan - General",
    "36": "Business Loan - Priority Sector - Agriculture",
    "37": "Business Loan - Priority Sector - Others",
    "38": "Business Non-Funded Credit Facility",
    "39": "Business Loan Against Bank Deposits",
    "40": "Microfinance - Business Loan",
    "41": "Microfinance - Personal Loan",
    "42": "Microfinance - Housing Loan",
    "43": "Microfinance - Other",
    "50": "Business Loan",
    "69": "Short Term / FinTech Loan",
  };

  idTypeMap: { [key: string]: string } = {
    "01": "PAN Card",
    "02": "Passport",
    "03": "Voter ID",
    "04": "Driving License",
    "05": "Ration Card",
    "06": "Aadhaar Number (UID)",
    "07": "Universal ID",
    "08": "CKYC Number",
    "09": "Other ID",
  };

  ownershipMap: { [key: string]: string } = {
    "1": "Individual",
    "2": "Authorised User",
    "3": "Guarantor",
    "4": "Joint",
  };

  telephoneTypeMap: { [key: string]: string } = {
    "01": "Mobile",
    "02": "Home / Landline",
    "03": "Office Phone",
    "07": "Other",
  };

  addressCategoryMap: { [key: string]: string } = {
    "01": "Permanent Address",
    "02": "Residence Address",
    "03": "Office Address",
    "04": "Other Address",
  };

  paymentFreqMap: { [key: string]: string } = {
    "01": "Weekly",
    "02": "Bi-Weekly",
    "03": "Monthly",
    "04": "Quarterly",
    "05": "Bi-Monthly",
    "06": "Daily",
    "07": "Half-Yearly",
    "08": "Yearly",
    "09": "Step / Bullet EMI",
  };

  constructor(
    private losService: LosService,
    private lmsService: LmsService,
    private _commonfunctions: CommonFunctions,
    private _MasterService: MasterService
  ) {}

  ngOnInit(): void {
    this.loadMasters();
    this.processCibilData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["cibilResponse"] && this.cibilResponse) {
      this.processCibilData();
    }
  }

  loadMasters(): void {
    this.losService
      .GET_CRC_MASTER_BY_CRCAGENCY({
        Crc_Agency: "1",
        Is_Firm: 0,
      })
      .subscribe((res: any) => {
        this.PurposeList = res || [];
      });

    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "SUIT FILED STATUS" })
      .subscribe((res: any) => {
        this.SuitFiled = res || [];
      });

    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "WO AND SETTLED STATUS" })
      .subscribe((res: any) => {
        this.CreditFacilityStatus = res || [];
      });

    this.losService.Get_Master_CibilAcore_List().subscribe((res: any) => {
      this.CibilAcore_List = res || [];
    });
  }

  processCibilData(): void {
    if (!this.cibilResponse) {
      return;
    }

    try {
      if (typeof this.cibilResponse === "string") {
        this.CibilData = JSON.parse(this.cibilResponse);
      } else {
        this.CibilData = JSON.parse(JSON.stringify(this.cibilResponse));
      }
    } catch (e) {
      console.error("Error parsing CibilData", e);
      this.CibilData = this.cibilResponse;
    }

    if (!this.CibilData) return;

    this.consumer =
      this.CibilData.consumerCreditData &&
      this.CibilData.consumerCreditData.length > 0
        ? this.CibilData.consumerCreditData[0]
        : null;

    this.summary = this.CibilData.consumerSummaryData || null;

    if (this.consumer && this.consumer.accounts) {
      this.processedAccounts = this.consumer.accounts.map((acc: any) => {
        const item = { ...acc };
        item.paymentEntries = this.buildPaymentHistoryEntries(item);
        item.yearlyHistory = this.buildYearlyPaymentHistory(item);
        item.isExpanded = true;
        return item;
      });
    } else {
      this.processedAccounts = [];
    }

    if (this.consumer && this.consumer.enquiries) {
      this.processedEnquiries = this.consumer.enquiries;
    } else {
      this.processedEnquiries = [];
    }
  }

  buildYearlyPaymentHistory(acc: any): Array<{ year: number; months: { [key: string]: string } }> {
    if (!acc.paymentHistory) return [];

    const historyStr = acc.paymentHistory.toString();
    const chunks: string[] = [];
    for (let i = 0; i < historyStr.length; i += 3) {
      chunks.push(historyStr.substring(i, i + 3));
    }

    let baseDate: Date;
    if (acc.paymentStartDate) {
      baseDate = this.parseCibilDateToObj(acc.paymentStartDate);
    } else if (acc.dateReported) {
      baseDate = this.parseCibilDateToObj(acc.dateReported);
    } else {
      baseDate = new Date();
    }

    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const monthDataMap: { [key: string]: string } = {};
    const yearsSet = new Set<number>();

    for (let i = 0; i < chunks.length; i++) {
      const d = new Date(baseDate.getFullYear(), baseDate.getMonth() - i, 1);
      const y = d.getFullYear();
      const m = d.getMonth();
      yearsSet.add(y);
      monthDataMap[`${y}_${m}`] = chunks[i];
    }

    const sortedYears = Array.from(yearsSet).sort((a, b) => b - a);
    const yearlyList: Array<{ year: number; months: { [key: string]: string } }> = [];

    sortedYears.forEach((year) => {
      const monthObj: { [key: string]: string } = {};
      monthNames.forEach((mName, mIdx) => {
        monthObj[mName] = monthDataMap[`${year}_${mIdx}`] || "-";
      });
      yearlyList.push({ year, months: monthObj });
    });

    return yearlyList;
  }

  buildPaymentHistoryEntries(acc: any): Array<{ monthYear: string; dpd: string; statusClass: string }> {
    if (!acc.paymentHistory) return [];

    const historyStr = acc.paymentHistory.toString();
    const chunks: string[] = [];
    for (let i = 0; i < historyStr.length; i += 3) {
      chunks.push(historyStr.substring(i, i + 3));
    }

    let baseDate: Date;
    if (acc.paymentStartDate) {
      baseDate = this.parseCibilDateToObj(acc.paymentStartDate);
    } else if (acc.dateReported) {
      baseDate = this.parseCibilDateToObj(acc.dateReported);
    } else {
      baseDate = new Date();
    }

    const entries: Array<{ monthYear: string; dpd: string; statusClass: string }> = [];

    for (let i = 0; i < chunks.length; i++) {
      const d = new Date(baseDate.getFullYear(), baseDate.getMonth() - i, 1);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yy = String(d.getFullYear()).slice(-2);
      const monthYear = `${mm}/${yy}`;
      const dpd = chunks[i];
      const statusClass = this.getDpdClass(dpd);

      entries.push({ monthYear, dpd, statusClass });
    }

    return entries;
  }

  parseCibilDateToObj(dateStr: string): Date {
    if (!dateStr || dateStr.length < 8) return new Date();
    const clean = dateStr.replace(/\D/g, "");
    if (clean.length >= 8) {
      const day = parseInt(clean.substring(0, 2), 10);
      const month = parseInt(clean.substring(2, 4), 10) - 1;
      const year = parseInt(clean.substring(4, 8), 10);
      const d = new Date(year, month, day);
      return isNaN(d.getTime()) ? new Date() : d;
    }
    return new Date();
  }

  formatDate(dateStr: any): string {
    if (!dateStr) return "-";
    const str = dateStr.toString().trim();
    const clean = str.replace(/\D/g, "");
    if (clean.length === 8) {
      const dd = clean.substring(0, 2);
      const mm = clean.substring(2, 4);
      const yyyy = clean.substring(4, 8);
      return `${dd}/${mm}/${yyyy}`;
    }
    if (str.includes("-") || str.includes("/")) {
      return str;
    }
    return str;
  }

  formatTime(timeStr: any): string {
    if (!timeStr) return "";
    const clean = timeStr.toString().replace(/\D/g, "");
    if (clean.length >= 6) {
      const hh = clean.substring(0, 2);
      const mi = clean.substring(2, 4);
      const ss = clean.substring(4, 6);
      return `${hh}:${mi}:${ss}`;
    }
    return timeStr;
  }

  formatCurrency(val: any): string {
    if (val === null || val === undefined || val === "") return "0";
    const num = Number(val);
    if (isNaN(num)) return val.toString();
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(num);
  }

  getPanNumber(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "01");
    return found ? found.idNumber : "-";
  }

  getDlNumber(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "04");
    return found ? found.idNumber : "-";
  }

  getVoterId(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "03");
    return found ? found.idNumber : "-";
  }

  getPassport(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "02");
    return found ? found.idNumber : "-";
  }

  getAadhaar(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "06");
    return found ? found.idNumber : "NOT DISCLOSED";
  }

  getCkyc(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "08");
    return found ? found.idNumber : "-";
  }

  getOtherId(): string {
    if (!this.consumer?.ids) return "-";
    const found = this.consumer.ids.find((id: any) => id.idType === "09" || id.idType === "05" || id.idType === "07");
    return found ? found.idNumber : "-";
  }

  getIdTypeName(code: string): string {
    if (!code) return "Identity Document";
    return this.idTypeMap[code] || `ID (${code})`;
  }

  getAccountTypeName(code: string): string {
    if (!code) return "OTHER ACCOUNT";
    return (this.accountTypeMap[code] || `ACCOUNT (${code})`).toUpperCase();
  }

  getOwnershipName(code: any): string {
    if (!code) return "INDIVIDUAL";
    return (this.ownershipMap[code.toString()] || "INDIVIDUAL").toUpperCase();
  }

  getTelephoneTypeName(code: string): string {
    if (!code) return "Phone";
    return this.telephoneTypeMap[code] || "Phone";
  }

  getAddressCategoryName(code: string): string {
    if (!code) return "Permanent";
    if (code === "01") return "Permanent";
    if (code === "02") return "Residence";
    if (code === "03") return "Office";
    return "Other";
  }

  getPaymentFrequencyName(code: string): string {
    if (!code) return "-";
    return (this.paymentFreqMap[code] || code).toUpperCase();
  }

  getEnquiryPurposeName(code: string): string {
    if (!code) return "OTHER";
    if (this.PurposeList && this.PurposeList.length > 0) {
      const found = this.PurposeList.find((p) => p.Code === code);
      if (found) return found.Value.toUpperCase();
    }
    return (this.accountTypeMap[code] || `PURPOSE (${code})`).toUpperCase();
  }

  getGenderName(gender: any): string {
    if (gender == "1") return "Female";
    if (gender == "2") return "Male";
    if (gender == "3") return "Third Gender";
    return "-";
  }

  getScoreValue(): number {
    if (
      this.consumer &&
      this.consumer.scores &&
      this.consumer.scores.length > 0
    ) {
      const s = parseInt(this.consumer.scores[0].score, 10);
      return isNaN(s) ? 0 : s;
    }
    return 0;
  }

  getFullConsumerAddress(): string {
    if (!this.consumer || !this.consumer.addresses || this.consumer.addresses.length === 0) {
      return '-';
    }
    const addr = this.consumer.addresses[0];
    const lines = [
      addr.line1 || addr.addressLine1,
      addr.line2 || addr.addressLine2,
      addr.line3 || addr.addressLine3,
      addr.line4 || addr.addressLine4,
      addr.line5 || addr.addressLine5,
      addr.city,
      addr.state || (addr.stateCode ? `State: ${addr.stateCode}` : ''),
      addr.pinCode ? `PIN - ${addr.pinCode}` : ''
    ].filter((item) => item && item.toString().trim().length > 0);

    return lines.length > 0 ? lines.join(', ') : '-';
  }

  readonly cibilReasonCodeMap: { [key: string]: string } = {
    "01": "Presence of severe delinquency with significant amount overdue",
    "02": "Delinquency reported on credit accounts in recent months",
    "03": "Proportion of delinquent accounts to active accounts is high",
    "04": "High utilization of revolving credit lines",
    "05": "Short credit history length or lack of established recent track record",
    "06": "Significant amount overdue reported as of recent update",
    "07": "Number of recent credit enquiries is high",
    "08": "Presence of write-off or suit-filed status on accounts",
    "09": "Lack of recent secured loan repayment track record",
    "10": "High ratio of unsecured credit to total outstanding balance",
    "11": "90+ DPD reported in last 12 months",
    "12": "Proportion of balances to credit limits is high",
    "13": "Multiple loan applications in past 30 days",
    "14": "Recent default or settlement reported on trade lines",
    "15": "Low repayment tenure completed on current active loans",
    "16": "Presence of Special Mention Accounts (SMA)",
    "17": "Insufficient track record on personal loan facilities",
    "18": "High outstanding balances across non-housing credit facilities",
    "19": "Presence of severe delinquency with significant amount overdue",
    "20": "High balance build-up over time",
    "21": "Lack of recent active credit accounts",
    "22": "Delinquency reported on asset-backed credit facilities",
    "23": "Number of credit accounts with overdue balances",
    "24": "High credit card balance utilization ratio",
    "25": "Multiple loan enquiries across different credit institutions",
    "26": "Recent increase in revolving credit card debt",
    "27": "High proportion of accounts with delinquency in credit history",
    "28": "Low credit age and high recent borrowing activity",
    "29": "Recent delinquency on commercial or retail loans",
    "30": "High outstanding balance relative to sanctioned amount"
  };

  readonly cibilExclusionCodeMap: { [key: string]: string } = {
    "01": "No credit history found / Insufficient data",
    "02": "All trade lines closed or inactive",
    "03": "Presence of active trade lines with standard payment history",
    "04": "Consumer deceased or identity mismatch",
    "05": "Restricted credit report"
  };

  findCibilScore(code: any, scoreName?: string): string {
    if (!code) return "";
    const cleanCode = code.toString().trim();
    if (this.CibilAcore_List && this.CibilAcore_List.length > 0) {
      const match = this.CibilAcore_List.find(
        (item) => item.Code == cleanCode && (!scoreName || item.ScoreName == scoreName)
      ) || this.CibilAcore_List.find((item) => item.Code == cleanCode);
      if (match && match.Explanation) {
        return match.Explanation;
      }
    }
    return this.cibilReasonCodeMap[cleanCode] || this.cibilReasonCodeMap[cleanCode.padStart(2, "0")] || "";
  }

  findExclusionExplanation(code: any): string {
    if (!code) return "";
    const cleanCode = code.toString().trim();
    return this.cibilExclusionCodeMap[cleanCode] || this.cibilExclusionCodeMap[cleanCode.padStart(2, "0")] || "";
  }

  getScoreDashArray(): string {
    const score = this.getScoreValue();
    const clamped = Math.max(300, Math.min(900, score || 300));
    const fraction = (clamped - 300) / 600;
    const arcLength = 235.619; // Math.PI * 75
    const blueLength = fraction * arcLength;
    return `${blueLength.toFixed(2)}, ${arcLength.toFixed(2)}`;
  }

  getArrowPoints(): string {
    const score = this.getScoreValue();
    const clamped = Math.max(300, Math.min(900, score || 300));
    const fraction = (clamped - 300) / 600;

    const cx = 100;
    const cy = 100;
    const R = 75;
    const tipRadius = R - 4; // Just touching the inner edge where the blue line ends
    const baseRadius = R - 22;
    const baseSpread = 0.14; // Angle spread for triangle base

    // Angle where the blue line ends (in radians)
    const angleRad = Math.PI * (1 - fraction);

    // Tip of triangle points directly to the line endpoint
    const tipX = cx + tipRadius * Math.cos(angleRad);
    const tipY = cy - tipRadius * Math.sin(angleRad);

    // Base corners of triangle sitting inside/outside the arc
    const base1X = cx + baseRadius * Math.cos(angleRad + baseSpread);
    const base1Y = cy - baseRadius * Math.sin(angleRad + baseSpread);

    const base2X = cx + baseRadius * Math.cos(angleRad - baseSpread);
    const base2Y = cy - baseRadius * Math.sin(angleRad - baseSpread);

    return `${tipX.toFixed(2)},${tipY.toFixed(2)} ${base1X.toFixed(2)},${base1Y.toFixed(2)} ${base2X.toFixed(2)},${base2Y.toFixed(2)}`;
  }

  getScoreFactors(): string[] {
    const factors: string[] = [];
    if (this.consumer && this.consumer.scores && this.consumer.scores.length > 0) {
      const sc = this.consumer.scores[0];
      if (sc.reasonCodes && sc.reasonCodes.length > 0) {
        sc.reasonCodes.forEach((rc: any, idx: number) => {
          const exp = this.findCibilScore(rc.reasonCodeValue, sc.scoreName);
          if (exp) {
            factors.push(`${idx + 1}. ${exp}`);
          } else {
            factors.push(`${idx + 1}. Delinquency / factor code: ${rc.reasonCodeValue}`);
          }
        });
      }
      if (sc.exclusionCodes && sc.exclusionCodes.length > 0) {
        sc.exclusionCodes.forEach((ec: any) => {
          const exp = this.findExclusionExplanation(ec.exclusionCodeValue);
          if (exp) {
            factors.push(`${factors.length + 1}. ${exp}`);
          }
        });
      }
    }
    if (factors.length === 0) {
      factors.push("1. High proportion of credit accounts with on-time payment track record");
      factors.push("2. Good mix of secured and unsecured credit facilities");
      factors.push("3. Low delinquency across active and closed trade lines");
    }
    return factors;
  }

  getScoreRiskInfo(): { label: string; badgeClass: string; color: string; desc: string } {
    const score = this.getScoreValue();
    if (score >= 750) {
      return {
        label: "Excellent / Low Risk",
        badgeClass: "score-excellent",
        color: "#00A6CA",
        desc: "High likelihood of approval with preferential interest rates.",
      };
    } else if (score >= 700) {
      return {
        label: "Good / Moderate Risk",
        badgeClass: "score-good",
        color: "#0284c7",
        desc: "Standard creditworthiness with healthy repayment track record.",
      };
    } else if (score >= 650) {
      return {
        label: "Fair / Medium Risk",
        badgeClass: "score-fair",
        color: "#d97706",
        desc: "Average credit score with occasional delays or high utilization.",
      };
    } else if (score > 0) {
      return {
        label: "Poor / High Risk",
        badgeClass: "score-poor",
        color: "#dc2626",
        desc: "High delinquency rate or historical overdue accounts.",
      };
    }
    return {
      label: "No Score / NTC",
      badgeClass: "score-ntc",
      color: "#64748b",
      desc: "New to Credit or insufficient credit history.",
    };
  }

  getDpdClass(dpd: string): string {
    if (!dpd) return "dpd-neutral";
    const upper = dpd.toUpperCase();
    if (upper === "000" || upper === "STD" || upper === "0") return "dpd-clear";
    if (upper === "XXX" || upper === "---" || upper === "***") return "dpd-neutral";
    const n = parseInt(dpd, 10);
    if (!isNaN(n)) {
      if (n === 0) return "dpd-clear";
      if (n <= 30) return "dpd-warning-low";
      if (n <= 89) return "dpd-warning-mid";
      return "dpd-danger";
    }
    if (upper === "SUB" || upper === "DBT" || upper === "LSS" || upper === "SMA") {
      return "dpd-danger";
    }
    return "dpd-neutral";
  }

  onDocsPrint(divName: string): void {
    const printElement = document.getElementById(divName);
    if (!printElement) {
      window.print();
      return;
    }

    const printContents = printElement.innerHTML;
    const popupWin = window.open("", "_blank", "width=1200,height=900");
    if (!popupWin) {
      window.print();
      return;
    }

    let stylesHtml = "";
    document.querySelectorAll("style, link[rel='stylesheet']").forEach((node) => {
      stylesHtml += node.outerHTML;
    });

    popupWin.document.open();
    popupWin.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>TransUnion CIBIL - Consumer CIR</title>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          ${stylesHtml}
          <style>
            @page {
              size: A4 portrait;
              margin: 10mm 8mm 10mm 8mm;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              box-sizing: border-box !important;
            }
            body {
              background: #ffffff !important;
              color: #1e293b !important;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif !important;
              padding: 0 !important;
              margin: 0 !important;
              font-size: 11px !important;
            }
            .no-print {
              display: none !important;
            }
            .cir-main-wrapper {
              width: 100% !important;
              max-width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            table {
              width: 100% !important;
              table-layout: auto !important;
            }
            .cir-section-block,
            .account-item-wrapper {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              margin-bottom: 14px !important;
            }
            .td-title {
              font-size: 11px !important;
              color: #00A6CA !important;
              white-space: nowrap !important;
            }
            .td-desc {
              font-size: 11.5px !important;
              word-break: break-word !important;
            }
            .yearly-dpd-tbl th,
            .yearly-dpd-tbl td {
              font-size: 9.5px !important;
              padding: 3px 1px !important;
            }
            .status-active, .active {
              color: #16a34a !important;
              font-weight: 700 !important;
            }
            .status-inactive, .inactive {
              color: #94a3b8 !important;
              font-weight: 700 !important;
            }
          </style>
        </head>
        <body>
          <div class="cir-main-wrapper">
            ${printContents}
          </div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.focus();
                window.print();
                window.close();
              }, 300);
            };
          </script>
        </body>
      </html>
    `);
    popupWin.document.close();
  }

  toggleAccount(acc: any): void {
    acc.isExpanded = !acc.isExpanded;
  }

  expandAllAccounts(): void {
    this.processedAccounts.forEach((acc) => (acc.isExpanded = true));
  }

  collapseAllAccounts(): void {
    this.processedAccounts.forEach((acc) => (acc.isExpanded = false));
  }
}
